import { useEffect, useState } from "react";
import { CustomerActivityAdd, CustomerActivityData } from "../types";
import { Column, Row } from "../../../containers";
import { AlignItems, JustifyContent, Wrap } from "../../../containers/types";
import { TextInput } from "../../../inputs";
import { Tags } from "../../../tag";
import { Heading } from "../../../typography";
import {
  useAlertStore,
  useGeneralStore,
  usePopupStore,
  useThemeStore,
} from "../../../../stores";
import { PopupBack, PopupClose } from "../../../../popup";
import { BackContainer, Vec2 } from "../../../../types";
import OptionList from "../../../optionlist";
import { LogoutIcon } from "../../../../assets/icons";
import { CustomerDetails } from "../../../customer";

const CustomerAddActivityPopup = <T extends {}>(
  props: BackContainer<CustomerActivityData, T>
) => {
  const activity = props.data as CustomerActivityAdd;
  const theme = useThemeStore((state) => state.theme);
  const popupProperties = usePopupStore((s) => s.popupProperties);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);

  useEffect(() => {
    setPopupProperties({
      ...popupProperties,
      style: {
        ...popupProperties.style,
        maxHeight: "80%",
        overflowY: "auto",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const getCustomerById = useGeneralStore((s) => s.getCustomerById);
  const pushAlert = useAlertStore((s) => s.pushAlert);
  const [mousePos, setMousePos] = useState<Vec2>({ x: 0, y: 0 });

  const onRightClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    e.preventDefault();
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  const gotoCustomerDetails = (): void => {
    const c = getCustomerById(activity.customer.$oid);
    if (!c) return pushAlert("مشتری پیدا نشد", "error");

    setPopupBody(
      <CustomerDetails<BackContainer<CustomerActivityData, T>>
        customer={c}
        back={{ component: CustomerAddActivityPopup, props }}
      />
    );
  };

  return (
    <Column
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Start}
      style={{ marginBottom: "1rem", position: "relative" }}
      gap={20}
      props={{ onContextMenu: onRightClick }}
    >
      <PopupClose />

      {props.back ? (
        <PopupBack Component={props.back.component} props={props.back.props} />
      ) : (
        <></>
      )}

      <OptionList
        mousePos={mousePos}
        options={[
          {
            title: "برو به مشتری",
            Icon: LogoutIcon,
            onClick: gotoCustomerDetails,
          },
        ]}
      />

      <Heading
        textStyles={{ marginTop: "1rem" }}
        size={19}
        color={theme.textOnOverlay}
      >
        ثبت مشتری جدید
      </Heading>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          style={{ maxWidth: 300 }}
          label="نام و نام خانوادگی"
          value={activity.fullname}
          inputProps={{ readOnly: true }}
        />
        <TextInput
          style={{ maxWidth: 300 }}
          label="کد ملی"
          value={activity.national_code}
          inputProps={{ readOnly: true }}
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          style={{ maxWidth: 300 }}
          label="تلفن همراه"
          value={activity.phone}
          inputProps={{ readOnly: true }}
        />
        <TextInput
          style={{ maxWidth: 300 }}
          label="آدرس"
          value={activity.address}
          inputProps={{ readOnly: true }}
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
      >
        <Tags>{activity.tags}</Tags>
      </Row>
    </Column>
  );
};

export default CustomerAddActivityPopup;
